import { ReplaceRowListCombinedProps } from './types';

const usePresenter = (props: ReplaceRowListCombinedProps): ReplaceRowListCombinedProps => {
  return props;
};

export default usePresenter;
